"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchProductChunkBatch = exports.getChunkLoadError = void 0;
const chunk_utils_1 = require("./chunk.utils");
const get_products_query_1 = require("../../gql/get-products.query");
const getProductChunkLoadErrorMessage = (productCount) => (`Failed to load product chunk (${productCount} products)`);
const getChunkLoadError = (error) => (error instanceof Error ? error : new Error('Failed to load product chunk'));
exports.getChunkLoadError = getChunkLoadError;
const hasChunkResponseError = (response) => Boolean(response.error);
const isFulfilledResponse = (response) => (response.status === 'fulfilled');
const fetchProductChunkBatch = (_a) => __awaiter(void 0, [_a], void 0, function* ({ client, variables, nextChunkRequestVariables, }) {
    const requestedProductCount = (0, chunk_utils_1.getChunkRequestProductCount)(nextChunkRequestVariables);
    const chunkLoadError = new Error(getProductChunkLoadErrorMessage(requestedProductCount));
    const settledResponses = yield Promise.allSettled(nextChunkRequestVariables.map((chunkVariables) => client.query({
        query: get_products_query_1.GET_PRODUCTS,
        fetchPolicy: 'no-cache',
        variables: Object.assign(Object.assign({}, variables), { after: chunkVariables.after, before: null, first: chunkVariables.first, last: null, lockedProductsFilter: undefined, shouldFetchLockedCount: false }),
    })));
    if (settledResponses.some((response) => !isFulfilledResponse(response) || hasChunkResponseError(response.value))) {
        throw chunkLoadError;
    }
    const responses = settledResponses.filter(isFulfilledResponse).map((response) => response.value);
    const productPresentations = responses
        .map((response) => { var _a, _b; return (_b = (_a = response.data) === null || _a === void 0 ? void 0 : _a.productTreeNode) === null || _b === void 0 ? void 0 : _b.productPresentationsNew; })
        .filter((presentation) => Boolean(presentation));
    if (productPresentations.length !== responses.length) {
        throw chunkLoadError;
    }
    return productPresentations;
});
exports.fetchProductChunkBatch = fetchProductChunkBatch;
